import  * as PowerBIConstants from './PowerBIContants';
import { produce } from "immer";
const assign = Object.assign || require('object.assign');

// The initial application state
const initialState = {};
// Takes care of changing the application state
export default function PowerBIReducer(state = initialState, action) {
    switch (action.type) {
        case PowerBIConstants.POWERBI_DEVICE_STATE_ADD: {
            if (state[action.payload]) {
                return state;
            }

            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isFetching: false,
                    isFetched: false,
                    isFetchingFailed: false,
                    deviceFound: false,
                    noDeviceFound: false,
                    powerBIData: null,
                    powerBIGroup: null,
                    incidentComponentState:null,
                    category:null,
                    fromDateIncidents:null,
                    toDateIncidents:null,
                    defaultIncidentComponentState:null
                }
            });
            return assign({}, state, newState);
        }
        case PowerBIConstants.POWERBI_DEVICE_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }
        case  PowerBIConstants.POWERBI_API_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isFetching: false,
                    isFetched: true,
                    powerBIData: action.payload.newState
                };
            });
            return assign({}, state, newState);
        }
        case PowerBIConstants.POWERBI_API_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isFetching: false,
                    isFetched: true,
                    deviceFound: false,
                    noDeviceFound: true,
                    isFetchingFailed: true
                };
            });
            return assign({}, state, newState);
        }

        // Get group Name
        case  PowerBIConstants.POWERBI_GROUP_API_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isFetching : false,
                    isFetched : true,
                    powerBIGroup : action.payload.newState
                };
            });
            return assign({}, state, newState);
        }
        case PowerBIConstants.POWERBI_GROUP_API_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isFetching: false,
                    isFetched: true,
                    deviceFound: false,
                    noDeviceFound: true,
                    isFetchingFailed: true
                };
            });
            return assign({}, state, newState);
        }

        case PowerBIConstants.INCIDENTS_START_DATE:{
            
            const newState = produce(state, (draft) => {
                draft[action.newState.deviceID] = {
                    ...draft[action.newState.deviceID],
                    incidentStartDate: action.newState.fromDateIncidents
                };
            });
            
            return assign({}, state,newState);
        }   
        case PowerBIConstants.INCIDENTS_END_DATE:{
            console.log("Redicer calue jjjj",action.newState.toDateIncidents,action.newState.deviceID)
            const newState = produce(state, (draft) => {
                draft[action.newState.deviceID] = {
                    ...draft[action.newState.deviceID],
                    incidentEndDate: action.newState.toDateIncidents
                };
            });
                return assign({}, state,newState);
            }
        case PowerBIConstants.INCIDENTS_DATE_SLICER_STATE:{
                    
            const newState = produce(state, (draft) => {
                draft[action.newState.deviceID] = {
                    ...draft[action.newState.deviceID],
                    slicerState: action.newState.slicerState
                };
            });
                    return assign({}, state,newState);
        }

        case PowerBIConstants.INCIDENTS_COMPONENT_SLICER_STATE:{
               
                const newState = produce(state, (draft) => {
                draft[action.newState.deviceID] = {
                    ...draft[action.newState.deviceID],
                    incidentComponentState: action.newState.incidentComponentState
                    };
                });
                        return assign({}, state,newState);
        }                
        case PowerBIConstants.DEFAULT_DATE_SLICER_STATE:{
             
            const newState = produce(state, (draft) => {
                draft[action.newState.deviceID] = {
                    ...draft[action.newState.deviceID],
                    defaultIncidentComponentState: action.newState.defaultIncidentComponentState
                };
            });
            return assign({}, state,newState);
        }                    
        
        case PowerBIConstants.INCIDENTS_CATEGORY_SLICER_STATE:{
                    console.log("action in INCIDENTS_COMPONENT_SLICER_STATE",action.newState.category)
            
            const newState = produce(state, (draft) => {
                draft[action.newState.deviceID] = {
                    ...draft[action.newState.deviceID],
                    category: action.newState.category
                    };
            });
            return assign({}, state,newState);
        }
                                break;
        default:
            return state;
    }
}